package com.patronat.top.features.auth.presentation.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import com.patronat.top.dto.AuthFlow
import com.patronat.top.features.auth.presentation.AuthEvent
import com.patronat.top.features.auth.presentation.AuthViewModel
import com.patronat.top.features.auth.presentation.AuthStep
import com.patronat.top.ui.atoms.AppButton
import com.patronat.top.ui.atoms.AppTabSelector
import com.patronat.top.ui.atoms.ButtonType
import com.patronat.top.ui.theme.*
import top.features.auth.generated.resources.Res
import top.features.auth.generated.resources.*

@Composable
actual fun AuthScreen(
    viewModel: AuthViewModel,
    onNavigateBack: () -> Unit
) {
    val state by viewModel.viewState.collectAsState()

    // Визначаємо, коли показувати кнопку "Назад" (на всіх кроках, крім перших)
    val showBackButton = state.step != AuthStep.LoginInput && state.step != AuthStep.RegisterInput

    // Визначаємо, коли показувати Таби (тільки на перших кроках)
    val showTabs = !showBackButton

    Scaffold(modifier = Modifier.fillMaxSize()) { _ ->
        Row(modifier = Modifier.fillMaxSize()) {

            // --- ЛІВА ЧАСТИНА (Без змін) ---
            Box(
                modifier = Modifier
                    .weight(1f)
                    .fillMaxHeight()
                    .background(Color.Black)
            ) {
                Image(
                    painter = painterResource(Res.drawable.login_bg),
                    contentDescription = null,
                    contentScale = ContentScale.Crop,
                    modifier = Modifier.fillMaxSize()
                )
                Box(modifier = Modifier.fillMaxSize().background(Color.Black.copy(alpha = 0.4f)))
                Column(
                    modifier = Modifier
                        .align(Alignment.Center)
                        .padding(horizontal = 60.dp)
                ) {
                    Text(text = stringResource(Res.string.hero_title), style = HeroTitle)
                    Spacer(modifier = Modifier.height(16.dp))
                    Text(text = stringResource(Res.string.hero_subtitle), style = HeroSubtitle)
                }
            }

            // --- ПРАВА ЧАСТИНА ---
            Column(
                modifier = Modifier
                    .weight(1f)
                    .fillMaxHeight()
                    .background(White)
                    .padding(horizontal = 40.dp),
                verticalArrangement = Arrangement.Top,
                horizontalAlignment = Alignment.CenterHorizontally
            ) {

                Spacer(modifier = Modifier.weight(0.15f).heightIn(min = 60.dp))

                Column(
                    modifier = Modifier
                        .widthIn(max = 448.dp)
                        .wrapContentHeight(),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {

                    if (showTabs) {
                        AppTabSelector(
                            options = listOf(
                                stringResource(Res.string.tab_login),
                                stringResource(Res.string.tab_registration)
                            ),
                            selectedIndex = if (state.flow == AuthFlow.LOGIN) 0 else 1,
                            onOptionSelected = { index ->
                                val newFlow = if (index == 0) AuthFlow.LOGIN else AuthFlow.REGISTRATION
                                viewModel.onEvent(AuthEvent.OnTabSelected(newFlow))
                            }
                        )
                        Spacer(modifier = Modifier.height(32.dp))
                    }

                    Column(
                        modifier = Modifier
                            .fillMaxWidth()
                            .fillMaxHeight(),
                        horizontalAlignment = Alignment.Start,
                        verticalArrangement = Arrangement.Center
                    ) {

                        if (showBackButton) {
                            AppButton(
                                text = stringResource(Res.string.back_btn),
                                onClick = { viewModel.onEvent(AuthEvent.OnBackClicked) },
                                type = ButtonType.BrownOutline,
                                leadingIcon = AppIcons.ArrowLeft,
                                modifier = Modifier
                                    .height(48.dp)
                                    .width(196.dp)
                            )
                            // Маленький відступ до заголовка форми
                            Spacer(modifier = Modifier.height(24.dp))
                        }

                        // САМА ФОРМА
                        when (state.step) {
                            AuthStep.LoginInput -> LoginContent(viewModel)
                            AuthStep.LoginVerify,
                            AuthStep.RegisterVerifyPhone,
                            AuthStep.RegisterVerifyEmail -> VerifyCodeContent(viewModel)
                            AuthStep.RegisterInput -> RegistrationContent(viewModel)
                        }
                    }
                }

                // 4. Заповнювач знизу
                Spacer(modifier = Modifier.weight(0.85f))
            }
        }
    }
}